var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "           _3tFC0J7LM5vBFxhKcMFTI6            _3716c89cVynH5CUm8IReM_         ",
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    stroke: "white",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1.33333714 C4,1.33333714 4,6.66666286 4,6.66666286 L0,11.4285714 L16,11.4285714 L12,6.66666286 C12,6.66666286 12,1.33333714 8,1.33333714 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333714,12 L5.33333714,13.3333371 C5.33333714,14.8060944 6.52724277,16 8,16 C9.47275723,16 10.6666629,14.8060944 10.6666629,13.3333371 L10.6666629,12",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.88737914e-15 L8,1.33333714",
    id: "Path",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6919b9a68f580c8e134dda8fd9a949a3.svg";
export { ForwardRef as ReactComponent };